import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { UserblockService } from './userblock.service';
import { LocalStorageService } from 'angular-2-local-storage';
import * as _ from 'lodash';

@Component({
    selector: 'app-userblock',
    templateUrl: './userblock.component.html',
    styleUrls: ['./userblock.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class UserblockComponent implements OnInit {
    user: any;
    constructor(public userblockService: UserblockService,
        private localStorage: LocalStorageService) {
        let roles = '';
        const storedRoles = this.localStorage.get('user-roles') as string[];
        if (storedRoles != null) {
            roles = _.join(storedRoles, ' ');
        }

        this.user = {
            picture: 'assets/img/user/01.jpg',
            name: this.localStorage.get('userName'),
            roles: roles
        };

    }

    ngOnInit() {
    }

    userBlockIsVisible() {
        return this.userblockService.getVisibility();
    }

}
